import React from 'react';
import { Typography, Box } from '@mui/material';

const CadastroPendencia: React.FC = () => {
  return (
    <div className="cadastro-pendencia-page">
      <Typography variant="h4" component="h1" gutterBottom>
        Cadastro Pendente
      </Typography>
      <Box>
        <Typography variant="body1">
          Página de cadastro pendente em desenvolvimento...
        </Typography>
      </Box>
    </div>
  );
};

export default CadastroPendencia; 